import {Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import { CommentsListWrapper } from './comments-list/CommentsList'
const CommentsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/*'
          element={
            <>
              <PageTitle>Comment List</PageTitle>
              <CommentsListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default CommentsPage
